import { useCallback, useEffect, useState } from 'react'

export const useLocalStorage = <T extends unknown = string>(
  storageKey: string,
  defaultValue?: T
): [T | undefined, (value?: T, callback?: () => void) => void] => {
  const stored = localStorage.getItem(storageKey)
  const [value, setValue] = useState(stored ? (JSON.parse(stored) as T) : defaultValue)

  const setLocalValue = useCallback(
    (newValue?: T, callback?: () => void) => {
      setValue(newValue)
      if (newValue !== undefined) {
        localStorage.setItem(storageKey, JSON.stringify(newValue))
      } else {
        localStorage.removeItem(storageKey)
      }
      if (callback) {
        callback()
      }
    },
    [storageKey]
  )

  useEffect(() => {
    if (value !== undefined) {
      localStorage.setItem(storageKey, JSON.stringify(value))
    } else {
      localStorage.removeItem(storageKey)
    }
  }, [value, storageKey])

  return [value, setLocalValue]
}
